import {Project} from "../domain/entities/project.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export class CreateProjectCommand extends AbstractCommand<Project> {

    public name: CommandName = CommandName.CREATE_PROJECT;

    public tags = ['entity', 'create', 'project'];

    constructor(payload: Project) {
        super('project', payload.uid, payload);
    }

}